/**
 * A unit can be eligible for both an open house and a video tour, but only one
 * card is shown — open house wins, since it is a dated event the renter can
 * miss. Both cards open the same tour chat.
 */
export function getUnitTourHighlight(listing) {
    if (!listing)
        return null;
    if (listing.onOpenHouse && listing.openHouseStartAt)
        return 'open_house';
    if (listing.hasVideoTour)
        return 'video_tour';
    return null;
}
